const data = [
  {
    'id':'1',
    'imageSrc': 'https://honeyguide.s3.amazonaws.com/assets/icons/247Support.png',
    'value': 'Change Dates via WhatsApp',
  },
  {
    'id':'2',
    'imageSrc': 'https://honeyguide.s3.amazonaws.com/assets/icons/cancelBooking.png',
    'value': '800+ Lodges',
  },
  { 
    'id':'3',
    'imageSrc': 'https://honeyguide.s3.amazonaws.com/assets/icons/bestPrice.png',
    'value': 'Price Match Guarantee.',
  }
];

export default data;



// WEBPACK FOOTER //
// ./src/screens/Lodge/Search/uvpData.js